export enum SymbolIDs {
	CIRCLE_SOLID,
  CIRCLE_REGULAR,
  CIRCLE_DOT_SOLID,
  CIRCLE_DOT_REGULAR,
  CARET_DOWN,
  CARET_UP,
  CARET_LEFT,
  CARET_RIGHT,
  SQUARE_CIRCLE,
  SQUARE_SOLID,
  SQUARE_REGULAR,
  CUBE,
  COMMENT_SOLID,
  COMMENT_REGULAR,
  COMMENT_ALT_SOLID,
  COMMENT_ALT_REGULAR,
  FLAG,
  STAR,
  MAP_MARKER,
  MAP_PIN,
  EXCLAMATION_CIRCLE,
  EXCLAMATION_TRIANGLE,
  PLUG,
  BOLT
}
export type SymbolSizes = 'normal' | 'half' | 'double';
export type SymbolInfo = {
	css:string;
  solid:boolean;
  size?: SymbolSizes;
  offsetX?:number;
  offsetY?:number;
}
export type SymbolSet = Array<SymbolInfo>;
export const IconSymbols:SymbolSet = [];
IconSymbols[SymbolIDs.CIRCLE_SOLID] = {
	css:'fas fa-circle',
  solid: true
}
IconSymbols[SymbolIDs.CIRCLE_REGULAR] = {
	css:'far fa-circle',
  solid: false
}
IconSymbols[SymbolIDs.CIRCLE_DOT_SOLID] = {
	css:'fas fa-circle-dot',
  solid: true
}
IconSymbols[SymbolIDs.CIRCLE_DOT_REGULAR] = {
	css:'far fa-circle-dot',
  solid: false
}
IconSymbols[SymbolIDs.CARET_DOWN] = {
	css:'fas fa-caret-down',
  solid: true,
  offsetX: 0,
  offsetY: 8
}
IconSymbols[SymbolIDs.CARET_UP] = {
	css:'fas fa-caret-up',
  solid: true,
  offsetX: 0,
  offsetY: -8
}
IconSymbols[SymbolIDs.CARET_LEFT] = {
	css:'fas fa-caret-left',
  solid: true,
  offsetX:8,
  offsetY:0
}
IconSymbols[SymbolIDs.CARET_RIGHT] = {
	css:'fas fa-caret-right',
  solid: true,
  offsetX:-8,
  offsetY:0
}
IconSymbols[SymbolIDs.SQUARE_CIRCLE] = {
	css:'fas fa-stop-circle',
  solid: true
}
IconSymbols[SymbolIDs.SQUARE_SOLID] = {
	css:'fas fa-square-full',
  solid: true
}
IconSymbols[SymbolIDs.SQUARE_REGULAR] = {
	css:'far fa-square-full',
  solid: false
}
IconSymbols[SymbolIDs.CUBE] = {
	css:'fas fa-cube',
  solid: true
}
IconSymbols[SymbolIDs.COMMENT_SOLID] = {
	css:'fas fa-comment',
  solid: true,
  offsetX: 15,
  offsetY: 13
}
IconSymbols[SymbolIDs.COMMENT_REGULAR] = {
	css:'far fa-comment',
  solid: false,
  offsetX:15,
  offsetY:13
}
IconSymbols[SymbolIDs.COMMENT_ALT_SOLID] = {
	css:'fas fa-comment-alt',
  solid: true,
  offsetX:6,
  offsetY:16
}
IconSymbols[SymbolIDs.COMMENT_ALT_REGULAR] = {
	css:'far fa-comment-alt',
  solid: false,
  offsetX:6,
  offsetY:16
}
IconSymbols[SymbolIDs.FLAG] = {
	css:'fas fa-flag',
  solid: true,
  offsetX: 14.5,
  offsetY: 16
}
IconSymbols[SymbolIDs.STAR] = {
	css:'fas fa-star',
  solid: true
}
IconSymbols[SymbolIDs.MAP_MARKER] = {
	css:'fas fa-map-marker-alt',
  solid: true,
  offsetX: 0,
  offsetY: 16
}
IconSymbols[SymbolIDs.MAP_PIN] = {
	css:'fas fa-map-pin',
  solid: true,
  offsetX:-0.5,
  offsetY:16
}
IconSymbols[SymbolIDs.EXCLAMATION_CIRCLE] = {
	css:'fas fa-exclamation-circle',
  solid: true
}
IconSymbols[SymbolIDs.EXCLAMATION_TRIANGLE] = {
	css:'fas fa-exclamation-triangle',
  solid: true
}
IconSymbols[SymbolIDs.PLUG] = {
	css:'fas fa-plug',
  solid: true,
  offsetX:0.5,
  offsetY:16
}
IconSymbols[SymbolIDs.BOLT] = {
	css:'fas fa-bolt',
  solid: true,
  offsetX:7,
  offsetY:15
}











